// Registro de erros do app (levantamento de 02/10, item A5).
//
// POR QUE EXISTE: sem isto um defeito de tela vira tela branca e ninguém fica sabendo. Aqui o erro vai para o
// console (com o prefixo [BeamCRM], para achar) e para uma lista curta em memória, que a tela de erro oferece
// para a pessoa copiar e mandar ao suporte. Não sai do navegador: mandar para um servidor (tabela no banco ou
// Sentry) é decisão à parte, com custo e privacidade a pesar.
//
// O QUE NÃO ENTRA: e-mail, nome, token ou qualquer dado da pessoa. Só hora, onde aconteceu, a rota e o erro.

const LIMITE = 20;
const guardados = [];

const rotaAtual = () => (typeof window !== 'undefined' && window.location ? (window.location.hash || window.location.pathname) : '');

/** Guarda e escreve no console. Aceita qualquer coisa que tenha sido lançada, não só Error. */
export function registrarErro(origem, erro, extra = {}) {
  const e = erro instanceof Error ? erro : new Error(String(erro?.message ?? erro));
  const registro = {
    quando: new Date().toISOString(),
    origem,
    mensagem: e.message,
    pilha: (e.stack || '').split('\n').slice(0, 8).join('\n'),
    rota: rotaAtual(),
    ...extra,
  };
  guardados.push(registro);
  if (guardados.length > LIMITE) guardados.shift();
  console.error(`[BeamCRM] erro (${origem}):`, e.message, registro);
  return registro;
}

export const ultimosErros = () => guardados.slice();
export const limparErros = () => { guardados.length = 0; };

/** O que a pessoa copia e cola para o suporte. */
export function textoParaSuporte(registro) {
  if (!registro) return '';
  return [
    'BeamCRM — detalhes do erro',
    `Hora: ${registro.quando}`,
    `Rota: ${registro.rota || '(desconhecida)'}`,
    `Onde: ${registro.origem}`,
    `Erro: ${registro.mensagem}`,
    registro.componente ? `Componente:\n${registro.componente}` : '',
    registro.pilha ? `Pilha:\n${registro.pilha}` : '',
  ].filter(Boolean).join('\n');
}

/**
 * Pega o que nenhum componente pega: erro lançado dentro de um evento (clique) e promessa rejeitada sem `catch`.
 * Devolve a função que desinstala. `alvo` é a `window`; os testes passam outro.
 */
export function instalarCapturaGlobal(alvo = window) {
  const aoErrar = (ev) => registrarErro('janela', ev.error ?? ev.message ?? 'erro desconhecido');
  const aoRejeitar = (ev) => registrarErro('promessa', ev.reason ?? 'promessa rejeitada sem motivo');
  alvo.addEventListener('error', aoErrar);
  alvo.addEventListener('unhandledrejection', aoRejeitar);
  return () => {
    alvo.removeEventListener('error', aoErrar);
    alvo.removeEventListener('unhandledrejection', aoRejeitar);
  };
}
